export default {
  create_time() {
    let date = new Date();
    // console.log(date);
    let year = date.getFullYear();
    let mounth = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    mounth < 10 ? mounth = `0${mounth}` : mounth;
    day < 10 ? day = `0${day}` : day;
    hour < 10 ? hour = `0${hour}` : hour;
    minute < 10 ? minute = `0${minute}` : minute;
    second < 10 ? second = `0${second}` : second;
    return `${year}/${mounth}/${day} ${hour}:${minute}:${second}`;
  },
  // 节流
  throttle: (() => {
    let timer = null;
    return function (func, wait = 500, immediate = true) {
      if (immediate) {
        if (!timer) {
          func();
          timer = setTimeout(() => {
            timer = null;
          }, wait);
        }

      } else {
        if (timer) {
          return;
        }
        timer = setTimeout(() => {
          func();
          timer = null;
        }, wait);
      }
    }
  })(),
  //  秒 转换成时分秒的形式
  toTime(times) {
    let second = times % 60;
    let minute = Math.floor((times % (1 * 60 * 60)) / (1 * 60));
    let hour = Math.floor(times / (1 * 60 * 60));
    second = second < 10 ? `0${second}` : second;
    minute = minute < 10 ? `0${minute}` : minute;
    hour = hour < 10 ? `0${hour}` : hour;
    return `${hour}/${minute}/${second}`
  },
  // 生成一个固定时间的加载
  loadingFn(timer) {
    let loading = () => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true)
        }, timer);
      })
    }
    return loading()
  },
  createLoading(timer) {
    let loading = () => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true)
        }, timer);
      })
    }
    return loading();
  },
  // 格式化富文本
  formatRichtextImg(text) {
    return text.replace(/\<img/gi, '<img style="max-width:100% !important;object-fit:cover;height:auto"  ');

    // return text.replace(/\<img/gi,   '<img class="rich_img img"  ' );
  },

  /**
   * @desription: 数字格式化，在过多得时候改变单位 
   * @author:
   * @params: value 需要格式化得数字 type 单位 zh  en
   * @returns: string
   * @update:
   */
  formatUnit(value, type = 'zh') {
    let unit = type == 'zh' ? '万' : 'w';
    let len = (value + '').length;
    let result = '';
    if (len <= 4) {
      result = value;
    } else {
      result = ((+value) / 10000).toFixed(1) + unit;
    }
    return result;
  },
}




// WEBPACK FOOTER //
// ./src/utils/methods.js